import React, { useEffect, useState } from 'react';
import { Button, Container } from '@mui/material';
import { dispatch, useSelector } from '../../../redux/store';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import Iconify from '../../../components/Iconify';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import DataGridTable from '../../../components/table/DataGridTable';
import { accessVerify, capitalize, safeJSONParse, utcMoment } from '../../../utils/common';
import { fCurrency } from '../../../utils/formatNumber';
import PermissionRequired from '../../errorPages/permissionRequired';
import { getMenuFoodAvailability } from '../../../redux/slices/stockManagementRedux/foodRedux';
import moment from 'moment/moment';

export default function MenuAvailability() {
  const { themeStretch } = useSettings();
  const [pickmeFoodLists, setpickmeFoodLists] = useState([]);

  let allLocations;
  let selectedLocation;
  ({ selectedLocation } = useSelector((state) => state.location));

  const { menuFoodAvailability } = useSelector((state) => state.food);

  useEffect(() => {
    dispatch(getMenuFoodAvailability());
  }, []);

  useEffect(() => {
    setpickmeFoodLists(
      menuFoodAvailability
        ?.filter((value) => value?.locationId === selectedLocation?.id || selectedLocation?.id === 1)
        ?.map((value) => {
          return {
            ...value,
            lastUpdated: utcMoment(value.lastUpdated).utc().format('MMMM Do YYYY, h:mm:ss a'),
          };
        })
    );
  }, [menuFoodAvailability, selectedLocation]);

  const columns = !pickmeFoodLists?.[0]
    ? []
    : Object.keys(pickmeFoodLists?.[0])
        .map((value) => {
          if (['locationId'].includes(value)) {
            return {};
          } else if (value === 'missingIngredients') {
            return {
              accessorKey: 'missingIngredients',
              header: 'Missing Ingredient',
              Cell: ({ row }) => {
                console.log(safeJSONParse(row?.original?.missingIngredients));
                return safeJSONParse(row?.original?.missingIngredients)
                  ?.map((value) => value?.ingredientName)
                  .toString();
              },
            };
          } else if (value === 'depreciatedAmountPerDay') {
            return {
              accessorKey: 'totalValue',
              header: 'Depreciated Amount Per Day',
              Cell: ({ row }) => {
                return fCurrency(row?.original?.depreciatedAmountPerDay);
              },
            };
          } else if (value === 'cookStatus') {
            return {
              accessorKey: 'cookStatus',
              header: 'Cook Status',
              Cell: ({ row }) => {
                const status = row?.original?.cookStatus || '';
                const isAvailable = status.toLowerCase() === 'available';
                return <span style={{ color: isAvailable ? 'green' : 'red', fontWeight: 'bold' }}>{status}</span>;
              },
            };
          } else {
            return {
              accessorKey: value,
              header: capitalize(value),
            };
          }
        })
        .filter((value) => value?.accessorKey);

  const [rowSelection, setRowSelection] = useState(false);

  return (
    <Page title={`Menu Availability`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={`Menu Availability`}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'Menu Availability',
              href: '',
            },
            { name: `Menu Availability` },
          ]}
          action={<></>}
        />

        {accessVerify('GENERAL_DATA') ? (
          <DataGridTable
            name={'Menu Availability'}
            data={pickmeFoodLists}
            column={columns}
            onRowClick={(row) => {}}
            isRowClickable={true}
            isLoading={false}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            enableRowSelection={false}
            enableRowActions={false}
            renderRowActionItems={(value, closeMenu) => []}
          />
        ) : (
          <PermissionRequired />
        )}
      </Container>
    </Page>
  );
}
